// Toast container for managing and displaying multiple toasts
// UPDATED: Replaced fragile CSS attribute-selector hack with proper Tailwind responsive classes
// Desktop: bottom-right, Mobile: bottom-center above navigation

import { Toast, ToastType } from './Toast';

export interface ToastItem {
  id: string;
  message: string;
  type: ToastType;
  duration: number;
}

interface ToastContainerProps {
  toasts: ToastItem[];
  onRemove: (id: string) => void;
}

const MAX_TOASTS = 3;

export function ToastContainer({ toasts, onRemove }: ToastContainerProps) {
  const visibleToasts = toasts.slice(-MAX_TOASTS);

  return (
    <div className="fixed z-[100] pointer-events-none bottom-20 left-1/2 -translate-x-1/2 md:left-auto md:right-5 md:translate-x-0">
      <div className="flex flex-col gap-3 pointer-events-auto">
        {visibleToasts.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={onRemove}
          />
        ))}
      </div>
    </div>
  );
}
